<div *ngIf="!showOld">
  <router-outlet></router-outlet>
</div>
<div class="row nova-font-style uploads" id="uploads-comp" *ngIf="showOld">
  <div class="col s12 m412 l4 xl4 ">
    <div class="left-container" id="upload-history-view">
      <div class="marginInternal" filterIcons [filterRows]="filterRows" [pageIn]="'Uploads'">
        <h2>History</h2>
        <!-- TOOLTIP TEMPLATE-->
        <ng-template #template let-anchor>
          <span>{{ anchor.nativeElement.innerText }}</span>
        </ng-template>
        <!-- MOBILE VIEW MSG -->
        <p id="profile-mobile-view-msg" class="text-red"><span class="k-icon k-i-warning"></span>{{mobileText}}</p>
        <!-- TOOLTIP ON HEADER-->
        <div kendoTooltip #tooltip="kendoTooltip" [tooltipTemplate]="template" filter="td.tooLong">
          <kendo-grid id="upload-history-grid" [kendoGridBinding]="gridView" [pageable]="true" [filterable]="true"
            [selectable]="false" [scrollable]="'None'" [resizable]="true" [sortable]="true" [filter]="gridState.filter"
            [pageSize]="gridState.take" [skip]="gridState.skip" [sort]="gridState.sort"
            (mouseover)="showTooltip($event)">

            <!-- MOBILE VIEW -->
            <kendo-grid-column media="(max-width: 992.98px)" title="Upload History">
              <ng-template kendoGridCellTemplate let-dataItem>
                <dl>
                  <dd>
                    <div><span class="bold">Created:</span>
                      {{dataItem.created | date: 'MM/dd/yyyy' }}
                    </div>
                  </dd>

                  <dd>
                    <div><span class="bold">Category:</span>
                      {{ dataItem.category }}
                    </div>
                  </dd>

                  <dd>
                    <div><span class="bold">File Name:</span>
                      {{ dataItem.fileNameOriginal }}
                    </div>
                  </dd>
                </dl>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column media="(min-width: 993px)" field="created" title="Created" [width]="110">
              <ng-template kendoGridCellTemplate let-dataItem>
                <div class="k-grid-ignore-click align-date">
                  <span>
                    {{dataItem.created | date: 'MM/dd/yyyy'}}
                  </span>
                </div>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column media="(min-width: 993px)" field="category" title="Category" [width]="120">
            </kendo-grid-column>
            <kendo-grid-column media="(min-width: 993px)" field="fileNameOriginal" title="File Name">
            </kendo-grid-column>
            <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage" width="100">
              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
              <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
              <kendo-pager-next-buttons></kendo-pager-next-buttons>
            </ng-template>
          </kendo-grid>
        </div>
      </div>
    </div>
  </div>
  <div class="col s8 m8 l8 xl8" id="file-upload-view">
    <div class="right-container">
      <div class="col xs12 s12 m12 l12 xl12">
        <h2>Upload Related Files</h2>
        <kendo-combobox [data]="uploadTypes" [popupSettings]="{ popupClass: 'nova-font-style text-black' }"
          [placeholder]="'Select a category...'" (valueChange)="valueChange($event)">
        </kendo-combobox>
      </div>

      <div id="upload-form" class="col xs12 s12 m12 l12 xl9 top-padding-16" *ngIf="isValidType">
        <div class="form-layout">
          <form #myForm="ngForm" novalidate [formGroup]="editForm">
            <div class="col s7">
              <h4 class="fileType">{{currentType}}</h4>
            </div>
            <hr />
            <div class="upload-form">
              <div>
                <label class="left-margin-10" id="location">Locations</label>
                <div>
                  <kendo-dropdownlist [data]="locations" [value]="location" (valueChange)="locationChange($event)"
                    [popupSettings]="{ popupClass: 'nova-font-style text-black' }" id="locationCode">
                  </kendo-dropdownlist>
                </div>
              </div>

              <div class="text-area-resize" *ngIf="currentType === 'Other'">
                <label class="left-margin-10" id="notifyEmail">Notify Email Address(es)<span
                    class="k-required">*</span></label>
                <div class="input-validation" id="inputTextArea">
                  <kendo-multiselect class="email-list" [data]="msraEmailList" [autoClose]="false"
                    formControlName="emailList" placeholder="Select email address(es)"
                    [popupSettings]="{ popupClass: 'nova-font-style role'}"></kendo-multiselect>
                </div>
              </div>
              <br *ngIf="currentType === 'Other'" />

              <div *ngIf="RcdAndAmt">
                <label class="left-margin-10" id="rCount">Record Count</label>
                <div>
                  <kendo-numerictextbox id="recordCount" class="form-control" [format]="'n0'"
                    formControlName="recordCount" [value]="0" [min]="0" [max]="MaxRecordCount" [autoCorrect]="true"
                    [spinners]="false">
                  </kendo-numerictextbox>
                  <span *ngIf="editForm.controls.recordCount.invalid" id="warning"
                    class="warning">{{recordCountWarningMsg}}</span>
                </div>
              </div>

              <div *ngIf="RcdAndAmt">
                <label class="left-margin-10" id="tAmount">Total Amount</label>
                <div>
                  <kendo-numerictextbox id="totalCount" formControlName="totalAmount" class="form-control"
                    [format]="'c'" [value]="0" [min]="0" [max]="MaxAmount" [autoCorrect]="true" [spinners]="false"
                    [decimals]="decimals">
                  </kendo-numerictextbox>
                  <span *ngIf="editForm.controls.totalAmount.invalid" id="warning"
                    class="warning">{{amountWarningMsg}}</span>
                </div>
              </div>

              <div *ngIf="currentType === 'Deductions'">
                <label class="left-margin-10">Process Month</label>
                <div class="deductionUpload">
                  <kendo-datepicker id="processMonth" (ngModelChange)='setModel($event)' [format]="'MMMM'"
                    [min]="minDate" [max]="maxDate" [value]="pped" class="form-control" formControlName="pped"
                    [ngModelOptions]="{standalone: true}" [navigation]="false" [activeView]="'year'"
                    [bottomView]="'year'" [placeholder]="'Please type or select the process month'"></kendo-datepicker>
                </div>
              </div>

              <div class="text-area-resize">
                <label class="left-margin-10" id="notes">Comments (Optional)</label>
                <div>
                  <textarea class="k-textarea" kendoTextArea [autoSize]="true" maxlength="240" formControlName="notes"
                    id="textArea"></textarea>
                </div>
              </div>

              <div class="left-margin-10" id="textMsg" *ngIf="currentType === 'Wages'">
                {{disclaimer}}
              </div>
              <div class="left-margin-10 file-upload">
                <kendo-upload #myUpload class="kendo-upload" [autoUpload]="false" [saveUrl]="uploadSaveUrl"
                  [multiple]="false" [disabled]="disableButton ||
                  (currentType === 'Other' && !editForm.value.emailList)" [removeUrl]="uploadRemoveUrl"
                  [restrictions]="fileRestrictions" (complete)="uploadComplete($event,myUpload)"
                  (upload)="uploadEventHandler($event, myForm.value)" (success)="uploadSuccess($event)"
                  (select)="selectEventHandler($event)" (error)="errorEventHandler($event)">
                  <br />
                  <kendo-upload-messages select="Select a file..">
                  </kendo-upload-messages>
                </kendo-upload>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <app-notification-loading></app-notification-loading>
</div>
